import { SimCardListItem } from "./SimCardListItem"
import { PuxItem, PuxList, PuxSkeletonText, PuxTypography } from "@phonero/pux-react"
import css from "./SimCardSlides.module.scss"
import React, { FC } from "react"
import { InfoBlock } from "@phonero/common-ux"

export const SimCardList = ({
  phoneNumber,
  products,
  count,
  animated,
  data,
  ...rest
}: Parameters<typeof SimCardListItem>[0] &
  Parameters<typeof SimCardListPlaceholder>[0]) => {
  return (
    <div style={{ maxWidth: 900, marginInline: "auto" }}>
      <PuxList lines="full" className={css["sim-card-list"]}>
        {products ? (
          <>
            <SimCardListItem
              phoneNumber={phoneNumber}
              products={products}
              data={data}
              editDenied={data?.mobileSubscription?.usageType === "IMPERSONAL"}
              {...rest}
            />
          </>
        ) : (
          <SimCardListPlaceholder animated={animated} count={count} />
        )}
      </PuxList>
    </div>
  )
}

export const SimCardListPlaceholder: FC<{
  count: number
  animated: boolean
}> = ({ count, animated }) => {
  return (
    <>
      {[...Array(count)].map((_value, index) => (
        <PuxItem key={index}>
          <PuxSkeletonText
            animated={animated}
            style={{ height: 200, width: 350, margin: "auto" }}
          />
        </PuxItem>
      ))}
    </>
  )
}
